import { render } from "./Sidebar.vue?vue&type=template&id=2185372a&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=2185372a&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=2185372a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2185372a"]])

export default __exports__